import { createActionGroup, props } from '@ngrx/store';

import {
  PaginatedRoomMemberList,
  PostRoomMemberRequest,
  RoomMember,
  Room,
  PostRoomRequest,
  Message,
} from '@offconon/core-api';

import { ChatEntity } from './chat.models';

export const ChatActions = createActionGroup({
  source: 'Chat',
  events: {
    'Load Chat Success': props<{ chat: ChatEntity[] }>(),
    'Load Chat Failure': props<{ error: any }>(),

    'Fetch Messages': props<{ roomId: number }>(),
    'Add Message': props<{ message: Message }>(),
    'Fetch Messages Success': props<{ messages: Message[] }>(),
    'Delete Message': props<{ id: number }>(),

    'Fetch Room Members': props<{
      room_id?: number;
      user_id?: number;
      co_worker_id?: number;
      business_id?: number;
    }>(),
    'Fetch Room Members Success': props<{
      paginatedRoomMemberList: PaginatedRoomMemberList;
      roomId: number;
    }>(),

    'Create Room Member': props<{ postRoomMemberRequest: PostRoomMemberRequest }>(),
    'Create Room Member Success': props<{ roomMember: RoomMember }>(),
    'Update Room Member': props<{ roomMember: RoomMember }>(),
    'Update Room Member Success': props<{ roomMember: RoomMember }>(),
    'Delete Room Member': props<{ id: number }>(),

    'Fetch Rooms': props<{
      roomType?: string;
      page?: number;
      pageSize?: number;
      searchJson?: {
        id?: number;
        room_type?: string;
      };
    }>(),
    'Fetch Rooms Success': props<{
      rooms: Room[];
      roomType: string;
      pagination: {
        page: number;
        pageSize: number;
        total: number;
        totalPages: number;
      };
    }>(),

    'Create Room': props<{ postRoomRequest: PostRoomRequest }>(),
    'Create Room Success': props<{ room: Room }>(),

    'Delete Room': props<{ id: number }>(),
    'Delete Room Success': props<{ id: number }>(),

    'Select Room': props<{ id: number }>(),
    'Select Room Success': props<{ id: number }>(),

    'Invite Users To Room': props<{ roomId: number; userIds: number[] | number }>(),

    'Leave Room': props<{ roomId: number }>(),
    'Leave Room Success': props<{ roomId: number }>(),
  },
});
